import { ref } from 'vue'
import { until } from '@vueuse/core'

const isReady = ref(false)

// {Promise}
const whenReady = until(isReady).toBe(true)

export const useReady = () => ({
  isReady,
  whenReady,
  setReady: (value = true) => {
    isReady.value = value
  },
})
